<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div
      v-show="time_limited"
      class="page-block">
      <time-limitation @time-limited="time_limited = true" />
    </div>
    <div
      v-if="!time_limited">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - 配信し放題プラン契約解約</h3>
      </div>
      <div class="page-block__inner">
        <div class="subsc-cancel-area">
          <div class="subsc-cancel-area__head-text">
            <p>配信し放題プランを解約した場合、配信し放題プラン契約期間中に登録済み楽曲は全て配信停止となります。</p>
            <p v-if="price_data.amount.price > 0">
              配信し放題プランご契約期間が1年未満の場合、解約料として
              {{ price_data.product.price + price_data.breakdown[1].price }}円（税込）が必要となります。
            </p>
          </div>
          <p class="subsc-cancel-area__text">
            確認事項をお読みいただき、ご確認・同意の上、チェックボックスにチェックを入れてください。<br>
            ご同意いただけない場合は解約できません。
          </p>
          <form>
            <div class="subsc-cancel-area__checkbox-wrap">
              <div
                v-for="(item,i) in checkList"
                :key="'check'+i"
                class="checkbox">
                <label>
                  <input
                    v-model="item.value"
                    type="checkbox"
                    :name="'check'+i"
                    :checked="item.value">
                  <div class="option-input"></div>
                  {{ item.text }}
                </label>
              </div>
            </div>
            <div
              v-if="price_data.amount.price > 0"
              class="settlement-plan-list">
              <table class="settlement-plan-list__table">
                <tbody class="settlement-plan-list__tbody">
                  <tr
                    v-for="item in price_data.breakdown"
                    :key="item.id">
                    <td class="u-text-align-left">{{ item.name }}</td>
                    <td>{{ item.price }}円</td>
                  </tr>
                  <tr class="total">
                    <td class="u-text-align-left">{{ price_data.amount.name }}</td>
                    <td>{{ price_data.amount.price }}円</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <alert-view
              title="処理が完了しませんでした"
              :errors="errors" />
            <div class="c-btn-wrap">
              <a
                :class="[{'c-btn--off':disableConfirm},'c-btn']"
                :disabled="!disableConfirm"
                @click.prevent="cancelClicked">
                解約する<span class="c-btn__icon-arrow"></span></a>
              <router-link
                :to="{ name: 'profile' }"
                class="c-btn c-btn--back c-btn--back-left">
                戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'
import AlertView from '../AlertView'
import TimeLimitation from './TimeLimitation'

export default {
  components: {
    HeaderBar,
    AlertView,
    TimeLimitation,
  },
  data() {
    return {
      checkList: [
        {
          text: '',
          value: false,
        },
        {
          text: 'サブスク契約期間中に登録済みの楽曲は全配信サイトで全て配信停止となります。',
          value: false,
        },
        {
          text: '都度課金プランで再登録する場合は、再度楽曲登録が必要となります。',
          value: false,
        },
        {
          text: '配信し放題プランで配信済み楽曲を、再度登録した場合でも過去の再生数はリセットされます。ご了承ください。',
          value: false,
        },
      ],
      price_data: {
        amount: {
          name: '',
          price: '',
        },
        product: {
          name: '',
          price: '',
        },
        breakdown: [],
      },
      disableConfirm: true,
      payment_method_id: 0,
      errors: [],
      time_limited: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['isSubscriber']),
  },
  watch: {
    checkList: {
      handler() {
        this.disableConfirm = !!this.checkList.find(check => !check.value)
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.isSubscriber || this.isBtoB) this.$router.push('/client/user/profile')
    this.fetchCancelPrice()
  },
  methods: {
    async fetchCancelPrice() {
      this.errors = []
      this.payment_method_id = this.$store.state.auth.subscription.settlement_method.method
      try {
        const { data } = await window.axios({
          method: 'GET',
          url: `/api/client/settlement/amount?service_plan=2&payment_method_id=${this.payment_method_id}&options[subscription][0]=99`,
        })
        if (data.result) {
          this.price_data.amount = data.amount
          this.price_data.product = data.product
          this.price_data.breakdown = data.breakdown
        } else {
          this.errors.push({ message: data.message })
        }
      } catch {
        this.errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
        this.$store.commit('decrementLoadingCount')
        this.$store.dispatch('progress/reset')
      }
      if (this.price_data.amount.price > 0) {
        this.checkList[0].text = `配信し放題プランのご契約期間が1年未満の場合、解約料として${this.price_data.product.price + this.price_data.breakdown[1].price}円（税込）が必要となります。`
      } else {
        this.checkList.splice(0, 1)
      }
    },
    async cancelClicked() {
      this.errors = []
      if (this.payment_method_id === 1) {
        try {
          const { data } = await window.axios.delete('/api/client/settlements/veritrans/card/subscription')
          if (data.result) {
            this.$router.push('/client/user/profile')
          } else {
            this.errors.push({ message: data.message })
          }
        } catch {
          this.errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
          this.$store.commit('decrementLoadingCount')
          this.$store.dispatch('progress/reset')
        }
      } else if (this.payment_method_id >= 2) {
        try {
          const { data } = await window.axios.delete('/api/client/settlements/veritrans/carrier/subscription')
          if (data.result) {
            if (Object.prototype.hasOwnProperty.call(data, 'responseContents')) {
              document.write(data.responseContents)
            } else {
              this.$router.push('/client/user/profile')
            }
          } else {
            this.errors.push({ message: data.message })
          }
        } catch {
          this.errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
          this.$store.commit('decrementLoadingCount')
          this.$store.dispatch('progress/reset')
        }
      }
    },
  },
}
</script>
